import { call, put, takeEvery } from "redux-saga/effects"

// Ecommerce Redux States
import {
  GET_VECTOR_DETAIL,
  GET_VECTORS,
  GET_VECTOR_COMMENTS,
  GET_AUTH_USER,
  UPDATE_VECTOR,
  DELETE_VECTOR,
} from "./actionTypes"

import {
  deleteVectorFail,
  deleteVectorSuccess,
  getAuthUsersFail,
  getAuthUsersSuccess,
  getVectorDetailFail,
  getVectorDetailSuccess,
  getVectorsFail,
  getVectorsSuccess,
  updateVectorFail
} from "./actions"

//Include Both Helper File with needed methods
import {
  getVectors,
  getVectorDetail,
  getVectorComents as getVectorComentsApi, 
  getAuthUsersResponse,
  updateVectors,
  deleteVectorsURL
} from "helpers/fakebackend_helper"

function* fetchVectors(props) {
  try {
    const response = yield call(getVectors, props.payload)
    yield put(getVectorsSuccess(response))
  } catch (error) {
    yield put(getVectorsFail(error))
  }
}

function* updateVectorsFun(props) {
  try {
    const response = yield call(updateVectors, props.payload)
    yield put(updateVectorSuccess(response))
  } catch (error) {
    yield put(updateVectorFail(error))
  }
}

function* fetchAuthUsers() {
  
  try {
    const response = yield call(getAuthUsersResponse) 
    yield put(getAuthUsersSuccess(response))
  } catch (error) {
    yield put(getAuthUsersFail(error))
  }
}

function* fetchVectorDetail({ vectorId }) {
  try {
    const response = yield call(getVectorDetail, vectorId)
    yield put(getVectorDetailSuccess(response))
  } catch (error) {
    yield put(getVectorDetailFail(error))
  }
}
function* deleteVectors(vectorId ) {
  try {
    const response = yield call(deleteVectorsURL, vectorId.payload)
    yield put(deleteVectorSuccess(response))
  } catch (error) {
    yield put(deleteVectorFail(error))
  }
}

function* vectorsSaga() {
  yield takeEvery(GET_VECTORS, fetchVectors)
  yield takeEvery(GET_VECTOR_DETAIL, fetchVectorDetail)
  yield takeEvery(UPDATE_VECTOR, updateVectorsFun)
  yield takeEvery(DELETE_VECTOR,deleteVectors)
  // yield takeEvery(GET_AUTH_USER, fetchAuthUsers)
}

export default vectorsSaga
